const holder = {};

const randomNumberGenerator = (key) => {
  if (!key) {
    return null;
  }

  let randomId = '';

  while (true) {
    randomId = Math.random().toString(36).substring(6);

    if (!holder[key] || holder[key].indexOf(randomId) === -1) {
      holder[key] = holder[key] || [];
      holder[key].push(randomId);
      break;
    }
  }

  return `${key}-${randomId}`;
};

export default randomNumberGenerator;
